import { render } from "./CardWhite.vue?vue&type=template&id=63e1eca6&scoped=true"
import script from "./CardWhite.vue?vue&type=script&lang=js"
export * from "./CardWhite.vue?vue&type=script&lang=js"

import "./CardWhite.vue?vue&type=style&index=0&id=63e1eca6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e1eca6"]])

export default __exports__